import React from "react";
import { Loader } from "rizzui/loader";

export default function MyLoader() {
  return (
    <div className="flex flex-row justify-center text-primary-dark items-center w-full h-full">
      <Loader />
    </div>
  );
}
